import { TextField } from '@mui/material'
import { Box } from '@mui/system'

interface NumberRangeInputsProps {
  minValueLabel: string
  maxValueLabel: string
  minValueName: string
  maxValueName: string
  minValue: number | null
  maxValue: number | null
  handleNumberInputChange: (minValue: number | null, maxValue: number | null) => void
  isRequired?: boolean
}

export default function NumberRangeInputs({
  minValueLabel,
  maxValueLabel,
  minValueName,
  maxValueName,
  minValue,
  maxValue,
  handleNumberInputChange,
  isRequired = false
}: Readonly<NumberRangeInputsProps>) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target
    const newValue = value === '' ? null : Number(value)

    if (name === minValueName) {
      handleNumberInputChange(newValue, maxValue)
    } else if (name === maxValueName) {
      handleNumberInputChange(minValue, newValue)
    }
  }

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const { name } = event.target

    if (minValue === null || maxValue === null) {
      return
    }

    if (name === minValueName && minValue > maxValue) {
      // If minValue is greater than maxValue, set maxValue to minValue
      handleNumberInputChange(minValue, minValue)
    } else if (name === maxValueName && maxValue < minValue) {
      // If maxValue is less than minValue, set minValue to maxValue
      handleNumberInputChange(maxValue, maxValue)
    }
  }

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      <TextField
        label={minValueLabel}
        name={minValueName}
        value={minValue ?? ''}
        onBlur={handleBlur}
        onChange={handleChange}
        sx={{ minWidth: 200 }}
        required={isRequired}
      />
      <TextField
        label={maxValueLabel}
        name={maxValueName}
        value={maxValue ?? ''}
        onBlur={handleBlur}
        onChange={handleChange}
        sx={{ minWidth: 200 }}
        required={isRequired}
      />
    </Box>
  )
}
